<div class="oph-page-header">
  <div class="oph-page-header__title-container">
    <span class="oph-page-header__title">{{ title() }}</span>
    <span class="oph-page-header__subtitle">{{ description() }}</span>
  </div>
  <div class="oph-page-header__actions">
    <div class="oph-page-header__search-input-container">
      <input
        #searchInputEl
        class="oph-page-header__search-input"
        type="text"
        [placeholder]="searchInputPlaceholder()"
        [formControl]="searchInputControl"
      />

      <oph-icon
        [ngClass]="{'oph-page-header__search-input-clear-icon--visible': searchInputControl.value}"
        class="oph-page-header__search-input-clear-icon"
        (click)="searchInputControl.setValue('')"
        [name]="'close'"
        [size]="22"
      />

      <oph-icon
        class="oph-page-header__search-input-search-icon"
        (click)="searchInputEl.focus()"
        [name]="'list-views/search'"
        [size]="22"
      />
    </div>

    <oph-button
      class="oph-page-header__primary-action-button"
      (buttonClick)="onPrimaryActionButtonClick()"
      color="green"
    >
      <mat-icon [svgIcon]="primaryActionButtonIcon()" />
      {{ primaryActionButtonText() }}
    </oph-button>
  </div>
</div>
